import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import TenantDetail from './pages/TenantDetail';
import Billing from './pages/Billing';
import System from './pages/System';
import AuditLogs from './pages/AuditLogs';
import AdminUsers from './pages/AdminUsers';

function AppContent() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [adminUser, setAdminUser] = useState<{
    email: string;
    displayName: string;
    role: string;
  } | null>(null);
  const location = useLocation();

  useEffect(() => {
    checkAuth();
  }, [location.pathname]);

  const checkAuth = async () => {
    try {
      const apiUrl = import.meta.env.VITE_API_URL || 'https://admin.sign.virtue.dk';
      const response = await fetch(`${apiUrl}/api/auth/me`, {
        credentials: 'include',
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setIsAuthenticated(true);
          setAdminUser(data.data);
        } else {
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f3f4f6',
      }}>
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          textAlign: 'center',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #e5e7eb',
            borderTopColor: '#3b82f6',
            borderRadius: '50%',
            margin: '0 auto 20px',
            animation: 'spin 1s linear infinite',
          }} />
          <div style={{ color: '#6b7280' }}>Loading...</div>
        </div>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />}
        />
        <Route
          path="/dashboard"
          element={isAuthenticated ? <Dashboard adminUser={adminUser} /> : <Navigate to="/login" />}
        />
        <Route
          path="/tenants"
          element={isAuthenticated ? <Tenants adminUser={adminUser} /> : <Navigate to="/login" />}
        />
        <Route
          path="/tenants/:tenantId"
          element={isAuthenticated ? <TenantDetail adminUser={adminUser} /> : <Navigate to="/login" />}
        />
        <Route
          path="/billing"
          element={isAuthenticated ? <Billing adminUser={adminUser} /> : <Navigate to="/login" />}
        />
        <Route
          path="/system"
          element={isAuthenticated ? <System adminUser={adminUser} /> : <Navigate to="/login" />}
        />
        <Route
          path="/audit-logs"
          element={isAuthenticated ? <AuditLogs adminUser={adminUser} /> : <Navigate to="/login" />}
        />
        <Route
          path="/admin-users"
          element={isAuthenticated ? <AdminUsers adminUser={adminUser} /> : <Navigate to="/login" />}
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
